import {loadData} from './utils';
import modalNavigation from './modal-navigation';
import {CommonOption, PageName} from './constants';

const windowWidth = window.innerWidth;

export default class FlatsPage {
  constructor() {
    if (new.target === FlatsPage) {
      throw new Error(`There is no opportunity to instantiate abstract class: FlatsPage`);
    }
    this.page = document.querySelector(`.page`);
    this.isMobile = windowWidth <= CommonOption.MOBILE_VERSION_WIDTH;
    this.data = [];
    this.locale = null;
  }

  init(locale) {
    this.locale = locale;
    this._bind();
    this._formatValues();
  };

  _formatValues() {
    const formatPhone = () => {
      const phones = this.page.querySelectorAll(`.js-phone`);
      const pattern = /\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{2})?[- ]?(\d{2})/g;
      const subst = ' ($1) $2 $3 $4';

      phones.forEach(phone => {
        phone.innerHTML = phone.innerHTML.replace(pattern, subst);
      })
    };

    formatPhone();
  };

  loadData(source, onSuccess) {
    loadData(source)
      .then((data) => {
        this.data = data;
        onSuccess(data);
      })
      .catch((error) => {
        console.log(error);
      })
  };

  _bind() {
    this._setModalHandlers();
  };

  bindHandlers() {
    //set handlers in heirs
  };

  _setModalHandlers = () => {
    modalNavigation.init(this.isMobile, PageName.FLATS, this.locale);
  };
}
